module.exports = __webpack_public_path__ + "static/media/starts_with_k.a62618fd.mp3";